module.exports = __webpack_public_path__ + "static/media/emma-hero-shadow.f893de93.svg";